export const tableHash: (str: string, tableSize: number) => number = (
  str,
  tableSize,
) => {
  let hash = 17; // Starting with a random prime number
  for (let i = 0; i < str.length; i++) {
    // Use a combination of prime numbers and character positions
    hash = (hash * 31 + str.charCodeAt(i)) % tableSize;
  }
  return hash;
};
